/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Mask_TitleInputs */

const en_landing_studio_mask_title = /** @type {(inputs: Landing_Studio_Mask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint what should change`)
};

const zh_landing_studio_mask_title = /** @type {(inputs: Landing_Studio_Mask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`涂抹要修改的区域`)
};

/**
* | output |
* | --- |
* | "Paint what should change" |
*
* @param {Landing_Studio_Mask_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_mask_title = /** @type {((inputs?: Landing_Studio_Mask_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Mask_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_mask_title(inputs)
	return zh_landing_studio_mask_title(inputs)
});
export { landing_studio_mask_title as "landing.studio.mask_title" }